var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"main-app"}},[_c('v-main',{staticClass:"pa-0"},[(_vm.showMenu)?_c('Menu',{on:{"shown":_vm.onMenuCollapse}}):_vm._e(),_c('RouterView',{staticStyle:{"overflow-x":"hidden"}}),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }